import { getSkip } from "common/skipper";
import log from "loglevel";
const handlers = {};
export function cut(ev) {
    handlers[ev.name](ev);
}
handlers["announceVideoPlay"] = function onAnnounceVideoPlay(ev) {
    const element = ev.videoElement;
    if (getSkip().skipDelay) {
        element.playbackRate = 10;
    }
    else {
        element.playbackRate = 1;
    }
    $(document).on("skipChange", changeVideoSkip);
};
handlers["announceShowNextButton"] = function (ev) {
    const element = ev.videoElement;
    // getSkip().skipDelay = false;
    if (getSkip().skipDelay) {
        element.playbackRate = 10;
    }
    else {
        element.playbackRate = 1;
    }
    element.playbackRate = 1;
    $(document).off("skipChange", changeVideoSkip);
};
function changeVideoSkip() {
    log.debug("skipChangeEventHandler");
    if (getSkip().skipDelay) {
        $("video").prop("playbackRate", 10);
    }
    else {
        $("video").prop("playbackRate", 1);
    }
}
//# sourceMappingURL=crossCutter.js.map